module.exports = __webpack_public_path__ + "static/media/Illus-Credit_1.cbc5fab3.png";